export default __webpack_public_path__ + "static/media/CNo.59-0.c19e968b.jpg";